<template>
  <b-row class="detailTabl">
    <b-col>
      <h6 class="text-center">Détail échantillon</h6>
      <div>
        <b-table
          class="detailConfirm"
          striped
          :items="items"
          :fields="localFields"
        >
          <template #cell(libelle)="data">
            <b-form-input type="text" v-model="data.item.libelle" maxlength="95" />
          </template>
          <template #cell(analyses)="data">
            <small v-for="(ana, index) in data.item.analyses" :key="index">
              {{ ana.ANA_NUM }} {{ ana.ANA_LIB }}<br />
            </small>
          </template>
        </b-table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ConfirmationEchantillonComponent',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isSac: false,
      localFields: ['libelle', 'analyses']
    }
  },
  mounted: function () {
    this.isSac = this.$root.user.login === 907 || this.$root.user.login === 9999

    // const vm = this

    // vm.buildLocalItems()
  },
  methods: {
    updateCommentaireLabo () {
      if (this.commentaireLabo !== '' && this.commentaireLabo !== undefined) {
        this.items.forEach(item => {
          item.commentaire = this.commentaireLabo
        })
      }
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmationEchantillonComponent.vue